<template>
  <div class="sForm">
    <el-card :shadow="shadow?'always':'never'">
      <el-row v-if="$slots.actions" slot="header" class="clearfix">
        <slot v-if="!responsive||isWindowSize('sm',true)" name="actions"></slot>
        <template v-else>
          <q-space></q-space>
          <q-btn @click="floatMenu=!floatMenu" flat round icon="menu"></q-btn>
        </template>
      </el-row>
      <div v-fill-height="fillHeight">
        <slot></slot>
      </div>
    </el-card>
    <q-dialog v-model="floatMenu" persistent
              :maximized="true"
              transition-show="slide-down"
              transition-hide="slide-up">
      <slot name="actions"></slot>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: "s-form",
  props: {
    responsive: {default: false},
    title: {type: String, default: null},
    shadow: {default: false},
    fillHeight: {type: [Number, Boolean], default: 20}
  },
  data() {
    return {

      floatMenu: false
    };
  },
  methods: {}
};
</script>
<style>
.sForm {
  padding-left: 5px;
  padding-right: 5px;
}
</style>
